import { inject } from 'vue';
import { sentryKey } from '@/infra/injection-keys';
import type { SentryType } from '../plugins/sentry';

export function useSentry(): SentryType {
  const sentry = inject(sentryKey);
  if (!sentry) throw new Error('Sentry plugin not installed');
  return sentry;
}
